module.exports = __webpack_public_path__ + "static/media/logo175.44c72eb2.png";